import OnBoardingCard from '../Components/OnBoardingCard';
// import sportsTraining from 'assets/img/sportsTrainingOnboarding.png';
import volunteerRegistration from 'assets/img/volunteerRegistration.jpg';
import managerOnboarding from 'assets/img/managerOnboarding.jpg';
// import sportsScientisOnbaording from 'assets/img/sportsScientisOnboarding.png';
import technicalOnboarding from 'assets/img/technicalOnboarding.jpg';
import coachesOnboarding from 'assets/img/coachesOnboarding.jpg';
import AthleteOnboarding from 'assets/img/athleteOnboarding.jpg';
// import upcomingRoleOnboarding from 'assets/img/upcomingRoleOnboarding.png';

const data = [
  { image: AthleteOnboarding, role: 'Athlete', signUpRole: 'athlete' },
  {
    image: technicalOnboarding,
    role: 'Technical Official',
    signUpRole: 'coach',
    route: '/register/form/221751471278458',
  },
  {
    image: coachesOnboarding,
    role: 'CDM/Deputy CDM',
    signUpRole: 'coach',
    route: '/register/form/222341643672453 ',
  },
  // { image: sportsTraining, role: 'Sports Training Center', signUpRole: 'coach' },
  // { image: sportsScientisOnbaording, role: 'Sports Scientist', signUpRole: 'coach' },
  {
    image: coachesOnboarding,
    role: 'Team Official',
    signUpRole: 'coach',
    route: '/register/form/222340774697464 ',
  },
  {
    image: managerOnboarding,
    role: 'Competition Manager',
    signUpRole: 'coach',
    route: '/register/form/221752497654465',
  },
  {
    image: volunteerRegistration,
    role: 'Volunteer Registration',
    signUpRole: 'coach',
    route: '/register/form/221741654462051',
  },
  // {
  //   image: upcomingRoleOnboarding,
  //   role: 'Upcoming User Role',
  //   variant: 'disabled',
  //   signUpRole: 'coach',
  // },
];
const OnBoarding = ({ setFormFields }) => {
  return (
    <>
      <div className="h-full w-full flex items-center flex-col justify-center">
        <h1 className="text-2xl md:text-3xl font-bold text-center mt-4 font-poppins">
          Please select your Role
        </h1>
        <div className="gap-x-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 grid md:gap-x-6 lg:gap-x-8 w-full max-w-2xl">
          {data.map((el, i) => (
            <OnBoardingCard key={i} {...el} setFormFields={setFormFields} />
          ))}
        </div>
      </div>
    </>
  );
};

export default OnBoarding;
